// ◉ xlVISION · Powering Business Together!
// © ExcelVision, Lda. — Braga, Portugal
// ( ·:·●●·:· ) xlVISION | Powering Business Together!
//
// ============================================================================
// A CIDADE DE CADA DIA DE UM PEDIDO — a regra da reserva, num sítio só (2026-10-08)
// ============================================================================
//
// 📗 Cliente, 2026-10-08: as secções «por planear» e «em espera» do fundo do mapa têm de mostrar
//    *«para além da linha simples as cidades também e todos os outros detalhes como acontece nas
//    alocações normais»*. Um pedido por planear ainda não tem alocações — a cidade de cada dia
//    tem de sair do PERCURSO (`pedido_ponto`), e tem de ser a MESMA que a reserva vai escrever.
//
// 📌 **Nasceu dentro de `reservar.ts`** (o `localPorDia` e a escolha do dia) e sai para aqui sem
//    mudar uma vírgula de comportamento: o mapa a pré-visualizar uma cidade e a reserva a gravar
//    outra era a família «duas formulações divergem». Guardado por `locais-do-pedido.test.ts`.
// ============================================================================
/**
 * O local REGISTADO de cada dia: o da pernoita quando há, senão o do outro ponto do dia.
 *
 * ⚠️⚠️ **A pernoita GANHA**, que é o que `localidade_id` significa (D-086: onde o motorista
 * dorme); o local de ENTRADA (recolha) vive à parte, em `local_embarque`. 📌 A ordem fazia-se no
 * `ORDER BY data, (tipo = 'pernoita')` da reserva; faz-se agora AQUI, para não depender de quem
 * chama trazer a ordem certa — uma regra que só funciona com a ordem certa quebra no dia em que
 * alguém lê os pontos de outra maneira.
 */
export function locaisRegistadosPorDia(pontos) {
    const ordenados = pontos
        .map((p, i) => ({ p, i }))
        .sort((a, b) => (a.p.dia < b.p.dia ? -1 : a.p.dia > b.p.dia ? 1 : 0) ||
        Number(a.p.tipo === 'pernoita') - Number(b.p.tipo === 'pernoita') ||
        a.i - b.i);
    const porDia = new Map();
    for (const { p } of ordenados) {
        if (p.localidade !== null && p.localidade !== '')
            porDia.set(p.dia, p.localidade);
    }
    return porDia;
}
/**
 * A cidade que a reserva escreve no dia `d` de um serviço que vai de `diaEmbarque` a `dia1`.
 *
 * O registado ganha; sem registo, o primeiro dia é a recolha, o último a largada (ou, sem ela, a
 * recolha), e um dia do meio herda a recolha — é a INFERÊNCIA da reserva (`origem_localizacao =
 * 'inferida'`), e quem a mostra deve dizê-lo (`registado: false`).
 */
export function localDoDiaDoServico(o) {
    const registado = o.localPorDia.get(o.data);
    if (registado !== undefined)
        return { local: registado, registado: true };
    const local = o.d === o.diaEmbarque
        ? (o.localidadeId ?? null)
        : o.d === o.dia1
            ? (o.localidadeFimId ?? o.localidadeId ?? null)
            : (o.localidadeId ?? null);
    return { local, registado: false };
}
//# sourceMappingURL=locais-do-pedido.js.map